const { getElements } = window.BAO.Utils
const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class DeviceSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousels()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.slide.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els.slide.selector)

    triggerEl.classList.toggle('sec-CollectionFilterButtons_Slide-active')
  }

  setupCarousels () {
    this.els.slides.elements.forEach(slidesEl => {
      const slidesCount = getElements(
        '[data-collection-filter-buttons-el="slide"]',
        {
          context: slidesEl,
        },
      ).length

      if (window.innerWidth >= 768 && slidesCount < 5) {
        slidesEl.classList.add(this.dataset.notFullClass)
      }

      const slidesPerView = Number(slidesEl.dataset.slidesPerView)

      return new KeenSlider(
        slidesEl,
        {
          selector: '.keen-slider__slide',
          loop: false,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: 2.5,
            spacing: 5,
          },
          breakpoints: {
            '(min-width: 768px)': {
              slides: {
                perView: slidesPerView,
                spacing: 0,
              },
            },
          },
        },
        [
          setInitialised(),
          useArrows({
            container: slidesEl.querySelector(
              '[data-collection-filter-buttons-el="arrows"]',
            ),
            next: slidesEl.querySelector(
              '[data-collection-filter-buttons-el="next"]',
            ),
            previous: slidesEl.querySelector(
              '[data-collection-filter-buttons-el="previous"]',
            ),
          }),
        ],
      )
    })
  }
}

if (!customElements.get('collection-filter-buttons')) {
  customElements.define('collection-filter-buttons', DeviceSelector)
}
